// src/app/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// Import all your reducers
import authReducer from '../features/auth/authSlice';
import companyReducer from "../features/company/companySlice";
import companyUserReducer from '../features/companyUser/companyUserSlice';
import cantineReducer from '../features/cantine/cantineSlice';
import terreniReducer from '../features/terreni/terreniSlice';
import stabilimentiReducer from '../features/stabilimenti/stabilimentiSlice';
import regionReducer from '../features/region/regionSlice';
import prodottoReducer from "../features/Prodotti/prodottiSlice";
import sensoriReducer from '../features/sensori/sensoriSlice';
import trasportoReducer from '../features/trasporti/trasportiSlice';
import giacenzeReducer from '../features/giacenze/giacenzeSlice';
import mezziReducer from '../features/Mezzi/mezziSlice';
import manutenzioneReducer from "../features/manutenzione/manutenzioneSlice";
import particelleReducer from "../features/particelle/particelleSlice";
import trattamentiReducer from "../features/trattamenti/trattamentiSlice";
import attrezzatureReducer from "../features/attrezzatura/attrezzaturaSlice";
import documentiReducer from "../features/documenti/documentiSlice"
import operatoriReducer from "../features/operatori/operatoriSlice"
import produzioneTrattamentiSliceReducer from "../features/produzione-trattamenti/produzione-trattamentiSlice"
import ricetteReducer from "../features/ricette/ricetteSlice"
import produzioniReducer from "../features/produzioni/produzioniSlice";
import produzioniFormReducer from "../features/produzioniFormData/produzioniFormDataSlice"

// Combine all reducers
const appReducer = combineReducers({
  auth: authReducer,
  company: companyReducer,
  companyUser: companyUserReducer,
  cantine: cantineReducer,
  terreni: terreniReducer,
  stabilimenti: stabilimentiReducer,
  region: regionReducer,
  prodotto: prodottoReducer,
  sensori: sensoriReducer,
  trasporto: trasportoReducer,
  giacenze: giacenzeReducer,
  mezzi: mezziReducer,
  manutenzione: manutenzioneReducer,
  particelle: particelleReducer,
  trattamenti: trattamentiReducer,
  attrezzature: attrezzatureReducer,
  documenti:documentiReducer,
  operatori: operatoriReducer,
  produzioneTrattamenti:produzioneTrattamentiSliceReducer,
  ricette:ricetteReducer,
  produzioni: produzioniReducer,
  produzioniForm: produzioniFormReducer
});
// Root reducer that can reset the state
const rootReducer = (state, action) => {
  // When logout action is dispatched, reset the state
  if (action.type === 'user/logoutUser') {
    // For Redux persist
    Object.keys(state).forEach(key => {
      storage.removeItem(`persist:${key}`);
    });
    // Return undefined to reset reducers to their initial state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
// Configure persist for the root reducer
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth','produzioni','ricette', 'company','produzioneTrattamenti', 'cantine','trasporto','sensori','prodotto','region','stabilimenti','terreni','documenti','attrezzature','trattamenti','particelle','manutenzione','mezzi','giacenze', 'operatori']
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);